export type ParsedTemplateFilterId = {
  category: string;
  templateTitle: string | null;
  includeNoTemplate: boolean;
};

const decode = (value: unknown) => decodeURIComponent(String(value).replace(/\+/g, '%20'));

export const parseTemplateFilterId = (id: unknown): ParsedTemplateFilterId | null => {
  const parts = String(id)
    .split('|')
    .map(p => p.trim())
    .filter(Boolean);

  const kv: Record<string, string> = Object.fromEntries(
    parts
      .map(part => part.split('='))
      .filter(([k, v]) => k && v !== undefined)
      .map(([k, v]) => [k, String(v)])
  );

  const category = kv.cat ? decode(kv.cat) : null;
  if (!category) {
    return null;
  }

  const templateTitle = kv.tpl ? decode(kv.tpl) : null;
  const includeNoTemplate = kv.noTpl === '1' && !templateTitle;

  return { category, templateTitle, includeNoTemplate };
};

export const mapSelectedTemplateFilterIdsToCategoryGroups = (ids: unknown[]) => {
  const decodedByCategory = new Map<
    string,
    { category: string; includeNoTemplate: boolean; templateTitles: string[] }
  >();

  ids.forEach(id => {
    const parsed = parseTemplateFilterId(id);
    if (!parsed) {
      return;
    }

    const current = decodedByCategory.get(parsed.category) ?? {
      category: parsed.category,
      includeNoTemplate: false,
      templateTitles: [],
    };

    if (parsed.includeNoTemplate) {
      current.includeNoTemplate = true;
    }
    if (parsed.templateTitle) {
      current.templateTitles.push(parsed.templateTitle);
    }

    decodedByCategory.set(parsed.category, current);
  });

  return Array.from(decodedByCategory.values()).map(group => ({
    ...group,
    templateTitles: Array.from(new Set(group.templateTitles)),
  }));
};
